import React, { ReactElement, useState } from 'react';
import {
	Brand,
	Masthead,
	MastheadMain,
	MastheadContent,
	MastheadBrand,
	Tooltip,
	Text,
} from '@patternfly/react-core';
import './Header.scss';
import HeaderContent from './HeaderContent';
import { HeaderMenuItem } from '../../helpers/headerHelper';
import { useNavigate } from 'react-router-dom';
import { useMount } from 'react-use';
import { ZoneSettingEnum } from '../../api/zone/ZoneSetting';
import { useApplication } from '../../components/user/ApplicationProvider';
import { getAccessibleTextColor } from '../../utilities';
import { isJsonObject } from '../../components/util/Helpers';
import { AppThemeConfig } from '../../helpers/sub-nav-contexts/sub-nav-context';

type Props = {
	headerText?: string;
	logoImg: string;
	menuItems: HeaderMenuItem[];
	backgroundHeaderColor?: string;
	backgroundMenuColor?: string;
};

export default function Header(props: Props): ReactElement {
	const { logoImg, menuItems } = props;
	const navigate = useNavigate();
	const [isFrameEnabled, setIsIframeEnabled] = useState<boolean>(true);
	const { zoneSettings } = useApplication();
	const [appLogo, setAppLogo] = useState(props.logoImg);

	useMount(() => {
		const iframeSetting = zoneSettings.find(
			(setting) => setting.zone_setting_enum_id === ZoneSettingEnum.iframeIntegration
		);
		const appThemeSetting = zoneSettings.find(
			(setting) => setting.zone_setting_enum_id === ZoneSettingEnum.applicationWindowTitle
		);

		if (iframeSetting) {
			if (!iframeSetting.enabled || iframeSetting.value != '1') {
				setIsIframeEnabled(false);
			}
		}

		if (appThemeSetting) {
			if (appThemeSetting.enabled && isJsonObject(appThemeSetting.value)) {
				const decoded = JSON.parse(appThemeSetting.value) as AppThemeConfig;

				if (decoded.logo_url) {
					setAppLogo(decoded.logo_url);
				}
			}
		}
	});
	return (
		<Masthead
			style={{
				paddingLeft: 0,
				background: props.backgroundHeaderColor ?? '#0073c3',
				color: getAccessibleTextColor(props.backgroundHeaderColor ?? '#002E57'),
			}}
		>
			<MastheadMain>
				{!isFrameEnabled && (
					<MastheadBrand className="pf-m-align-items-center pf-m-justify-content-space-between">
						<Tooltip
							content="Home"
							flipBehavior={['bottom']}
						>
							<Text
								style={{ display: 'inline-flex', fontSize: '24px', color: 'white' }}
								onClick={() => navigate('/')}
							>
								<Brand
									alt={'ZeroedIn Technologies'}
									src={appLogo}
									className="zin-header-logo"
								/>
							</Text>
						</Tooltip>
					</MastheadBrand>
				)}

				<MastheadContent
					style={{
						background: props.backgroundMenuColor ?? '#d2d2d2',
						color: getAccessibleTextColor(props.backgroundMenuColor ?? '#d2d2d2'),
					}}
				>
					<HeaderContent menuItems={isFrameEnabled ? menuItems : menuItems.slice(1)} />
				</MastheadContent>
			</MastheadMain>
		</Masthead>
	);
}
